/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsigneeDeliveryNoteBundlesArrayV3 } from '../../models/consignee-delivery-note-bundles-array-v-3';
import { DeliveryNoteBundlesFilterProperties } from '../../models/delivery-note-bundles-filter-properties';
import { KeyType } from '../../models/key-type';
import { SortType } from '../../models/sort-type';

export interface GetConsigneeDeliveryNoteBundlesV3$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * Array of organization site keys to fetch data from (max 1000). If provided, overrides the path parameter.
 */
  organizationSiteKeys?: Array<KeyType>;

/**
 * Maximum number of items to return
 */
  limit?: number;

/**
 * Number of items to skip
 */
  offset?: number;

/**
 * Sort direction (asc or desc)
 */
  sort?: SortType;

/**
 * Field to sort by for bundles
 */
  sortBy?: 'dateCreated' | 'checkoutDate' | 'dateClosed' | 'name' | 'bundleNumber' | 'consignorLoadCarrierExchange' | 'status' | 'consignorName' | 'consigneeName' | 'carrierName' | 'discrepancies' | 'palletTickets';

/**
 * Field to filter consignee delivery note bundles by
 *
 * @deprecated
 */
  filterProperty?: DeliveryNoteBundlesFilterProperties;

/**
 * Value to filter by (partial match)
 *
 * @deprecated
 */
  filterValue?: string;

/**
 * Case-insensitive partial match using the existing name field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  name?: string;

/**
 * Case-insensitive partial match using the existing bundleNumber field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  bundleNumber?: string;

/**
 * Case-insensitive partial match using the existing status field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  status?: string;

/**
 * Case-insensitive partial match using the existing consignorName field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  consignorName?: string;

/**
 * Case-insensitive partial match using the existing carrierName field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  carrierName?: string;

/**
 * Case-insensitive partial match using the existing consigneeName field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  consigneeName?: string;

/**
 * Case-insensitive partial match using the existing discrepancies field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  discrepancies?: string;

/**
 * Case-insensitive partial match using the existing palletTickets field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  palletTickets?: string;

/**
 * Case-insensitive partial match using the existing dateClosed field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  dateClosed?: string;

/**
 * Case-insensitive partial match using the existing dateCreated field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  dateCreated?: string;

/**
 * Case-insensitive partial match using the existing checkoutDate field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  checkoutDate?: string;

/**
 * Filter for not closed items only (bundles, tours, delivery notes)
 */
  filterNotClosed?: boolean;

/**
 * If true, only return bundles where at least one delivery note has a discrepancy (normal or fine). Uses the bundle.discrepancies flag for efficient filtering.
 */
  filterOnlyDiscrepancies?: boolean;

/**
 * Case- and accent-insensitive substring search across all text fields
 * of the entity (numbers, names, file names, date strings). Minimum 3
 * characters. Can be combined with filterProperty/filterValue (results
 * must match both). Search results are eventually consistent: newly
 * written documents can take about one second to appear.
 */
  search?: string;
}

export function getConsigneeDeliveryNoteBundlesV3(http: HttpClient, rootUrl: string, params: GetConsigneeDeliveryNoteBundlesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeDeliveryNoteBundlesArrayV3>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeDeliveryNoteBundlesV3.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.query('organizationSiteKeys', params.organizationSiteKeys, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sort', params.sort, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('filterProperty', params.filterProperty, {});
    rb.query('filterValue', params.filterValue, {});
    rb.query('name', params.name, {});
    rb.query('bundleNumber', params.bundleNumber, {});
    rb.query('status', params.status, {});
    rb.query('consignorName', params.consignorName, {});
    rb.query('carrierName', params.carrierName, {});
    rb.query('consigneeName', params.consigneeName, {});
    rb.query('discrepancies', params.discrepancies, {});
    rb.query('palletTickets', params.palletTickets, {});
    rb.query('dateClosed', params.dateClosed, {});
    rb.query('dateCreated', params.dateCreated, {});
    rb.query('checkoutDate', params.checkoutDate, {});
    rb.query('filterNotClosed', params.filterNotClosed, {});
    rb.query('filterOnlyDiscrepancies', params.filterOnlyDiscrepancies, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsigneeDeliveryNoteBundlesArrayV3>;
    })
  );
}

getConsigneeDeliveryNoteBundlesV3.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-note-bundles';
